define(() => {
    "use strict";

    const MAX_LENGTH = 256;
    const MIN_LENGTH = 8;
    const SPECIAL_CHARS = "`~!@#$%^&*()_\\-+={}[\\]|:;\"'<>,.?/\\\\";
    const LOWER_CASE = "(?=.*[a-z])";
    const UPPER_CASE = "(?=.*[A-Z])";
    const DIGIT = "(?=.*\\d)";
    const SPECIAL_CHAR = `(?=.*[${SPECIAL_CHARS}])`;
    const LENGTH = `.{${MIN_LENGTH},${MAX_LENGTH}}`;
    const LENGTH_PATTERN = new RegExp(LENGTH);
    const LOWER_CASE_PATTERN = new RegExp(LOWER_CASE);
    const UPPER_CASE_PATTERN = new RegExp(UPPER_CASE);
    const DIGIT_PATTERN = new RegExp(DIGIT);
    const SPECIAL_CHAR_PATTERN = new RegExp(SPECIAL_CHAR);
    const VALIDATION_PATTERN = new RegExp(LOWER_CASE + UPPER_CASE + DIGIT + SPECIAL_CHAR + LENGTH);

    /**
     * Validates the quality of a password.
     * <p>
     * Validates using the following rules:
     * <li>Must include at least one English upper case letter (e.g., A, B, C, ...Z)
     * <li>Must include at least one English lower case letter (e.g., a, b, c, ...z)
     * <li>Must include at least one Westernized Arabic numeral (e.g., 1, 2, ...9)
     * <li>Must include at least one Non-alphanumeric ("special characters”) (e.g., ?,!,%,$,#, etc)
     * <li>Minimum 8 characters
     * <li>Maximum 256 characters
     *
     * @class PasswordQualityValidator
     * @author Poul Henriksen
     */
    return {

        /**
         * Checks whether the given password is valid.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password is good enough.
         */
        isValid(password) {
            return VALIDATION_PATTERN.test(password);
        },

        /**
         * Checks whether the given password contains at least one lower case character.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password contains a lower case character.
         */
        containsLowerCase(password) {
            return LOWER_CASE_PATTERN.test(password);
        },

        /**
         * Checks whether the given password contains at least one upper case character.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password contains an upper case character.
         */
        containsUpperCase(password) {
            return UPPER_CASE_PATTERN.test(password);
        },

        /**
         * Checks whether the given password contains at least one digit.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password contains a digit.
         */
        containsDigit(password) {
            return DIGIT_PATTERN.test(password);
        },

        /**
         * Checks whether the given password contains at least one special character.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password contains a special character.
         */
        containsSpecialCharacters(password) {
            return SPECIAL_CHAR_PATTERN.test(password);
        },

        /**
         * Checks whether the given password has the minimum required length.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password has the minimum required length.
         */
        hasMinimumLength(password) {
            return LENGTH_PATTERN.test(password);
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/util/PasswordQualityValidator.js